/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { AsideMenu } from "../AsideMenu";

export const ReportMenu = ({ destination = "/reports" }) => {
  const reportMenuList = [
    { title: "Users by Trade Activity", route: "activity" },
    { title: "Users by Last Trade Date", route: "last-traded" },
    { title: "Accounts by Holding Type", route: "holding-type" },
  ];

  return (
    <div className="d-flex flex-column h-100">
      <div className="h-100 overflow-auto">
        {reportMenuList.map((reportMenuItem, i) => (
          <AsideMenu.NavItem
            to={`${destination}/${reportMenuItem.route}`}
            key={i}
          >
            {`${reportMenuItem.title}`}
          </AsideMenu.NavItem>
        ))}
      </div>
    </div>
  );
};
